import { FC } from 'react';
import { ManagedCommItem } from '../../../../../../hooks/use-communications/types/managed-communication';
import { ManagedCommCardTitle } from '../shared/title/managed-comm-card-title';
import { ManagedCommCard, ManagedCommCardWrapper, ManagedCommSignature } from '../styles';

interface PhoneMangedCommCardProps {
  communication: ManagedCommItem;
}

export const PhoneMangedCommCard: FC<PhoneMangedCommCardProps> = (props) => {
  const { communication } = props;

  return (
    <ManagedCommCardWrapper>
      <ManagedCommCard>
        <ManagedCommCardTitle communication={communication} disableClick={true} />
      </ManagedCommCard>
      <ManagedCommSignature communication={communication} />
    </ManagedCommCardWrapper>
  );
};
